<template>
  <!--空调服务协议界面内容 -->
  <div style="width:100%;height:calc(100vh - 50px);overflow: hidden;" ref="xiaodianfragment">
    <div>
      <hint></hint>
      <question-list :Datalist="datalist" @scrollto="ScrollTo" :scroll="scroll"></question-list>
      <!-- <div class="struction_style" id='airstruction' v-html="struction">
      :style="{height:screenHeight+'px'}"
    </div> -->
      <xiaodian-charge class="struction_style" />
    </div>
  </div>
</template>

<script>
import hint from './hint.vue'
import QuestionList from './questionList.vue'
import { xiaodianinstruction } from '../struction/meilingXiaodian'
import XiaoDianCharge from './XiaoDianCharge.vue';
import BScroll from '@better-scroll/core'
export default {
  name: "Aircondition",
  data() {
    return {
      screenHeight: 500,
      datalist: [
        { des: '·厨卫、净水及小家电产品保修政策', ref: 'otherinstruction', href: '#xiaodian01' },
        { des: '·之前所有产品保修政策', ref: 'otherdeadline', href: '#xiaodian02' },
        { des: '·注意事项', ref: 'otherdeadline', href: '#xiaodian03' },
        { des: '·免责条款', ref: 'otherdeadline', href: '#xiaodian04' },
        { des: '·安装辅材收费标准', ref: 'otherdeadline', href: '#xiaodian05' },
        { des: '·厨卫家电类保外维修收费指导标准', ref: 'otherdeadline', href: '#xiaodian06' },
        { des: '·拆机、移机统一收费指导标准(元)', ref: 'otherdeadline', href: '#xiaodian07' },
        { des: '·小电类保外维修指导收费标准', ref: 'otherdeadline', href: '#xiaodian08' }
      ],
      struction: xiaodianinstruction.xiaodianTitle + xiaodianinstruction.xiaodianContent,
      scroll:'',
    }
  },
  props: {
    active: {
      type: String,
      default:'',
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight - 320;
    console.log('xiaodianinstruction :>> ', xiaodianinstruction);
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.xiaodianfragment, {
        click: true,
        scrollY: true,
        bounce: true,
      });
    });
  },
  methods: {
    ScrollTo: function (ref) {
      var updistance = document.getElementById("airstruction").offsetTop;
      var distance = document.getElementById(ref).offsetTop;
      var scrolldis = document.getElementById('airstruction').scrollTop = distance - updistance - 10;
    }
  },
  components: {
    'hint': hint,
    'question-list': QuestionList,
    'xiaodian-charge': XiaoDianCharge
  },
  watch: {
    active(newValue,oldValue){
      if(newValue === "meiling_container"){
        this.scroll.refresh();
      }
    }
  }
}
</script>

<style>
.struction_style {
  width: 92%;
  display: inline-block;
  text-align: left;
  /* padding-left: 4%; */
  line-height: 120%;
  overflow-y: scroll;
  background: #FAFAFA;
}

.struction_style p {
  line-height: 25px;
  color: #999;
  font-size: 14px;
  margin: 0;
}

.struction_style p.title {
  font-size: 18px;
  color: #333;
  margin: 15px 0;
}
.inner {
  height: calc(100% + 1px);
}
</style>



// WEBPACK FOOTER //
// src/components/MeilingXiaoDian.vue